import { withServerContext } from '@bingads-webui-campaign-react/server-context';
import { withScope } from '@bingads-webui-react/scope-service';
import { MmcDataSource } from './mmc-data-source';
// import { configs } from './index'; // toggle comment for local development

const initDataSource = MmcDataSource.init;

function DataSourceInitializer(props) {
  const { scope, serverContext } = props;

  initDataSource({
    host: serverContext.ServicesEndpoints.MmcAPI,
    // host: `${configs.hosts.dev}/ODataApi/`, // toggle comment for local development
    oDataToken: serverContext.Token,
    aid: scope.values.aid,
    cid: serverContext.CurrentAccount.AdvertiserCustomerID,
    uid: scope.values.uid,
    error(xhr) {
      if (xhr && (xhr.status === 401)) {
        const domain = serverContext.NonAzureDomain || '';
        window.location.href = `${domain}/default.aspx?reason=1&msg=sessionexpired`;
      }
    },
  });

  return null;
}

export const MmcDataSourceInitializer = withServerContext(withScope(DataSourceInitializer));
